import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import PageMenu from '../../../blocks/PageMenu/PageMenu';
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";

import useGetInfoDeclaracionJuradaCeseActividadDirecta from "services/record/DeclaracionJuradaCeseActividadDirecta/useGetInfoDeclaracionJuradaCeseActividadDirecta";
import useGetDeclaracionJuradaCeseActividadDirectaByID from "services/record/DeclaracionJuradaCeseActividadDirecta/useGetDeclaracionJuradaCeseActividadDirectaByID";
import useGetDeclaracionJuradaCeseActividadDirectaByUser from "services/record/DeclaracionJuradaCeseActividadDirecta/useGetDeclaracionJuradaCeseActividadDirectaByUser";

import useDecode from "hooks/useDecode";

import ManagementFormCardList from 'components/blocks/ManagementNewForms/CardList/ManagementFormCardList';

import Loader from "components/blocks/Loader/Loader";
import ErrorDisplay from "components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla";
import DeclaracionJuradaCeseActividadDirecta from "./DeclaracionJuradaCeseActividadDirecta";

const GridDeclaracionJuradaCeseActividadDirecta = ({ expedienteId = null, origen = null }) => {

    const {
        getDeclaracionJuradaCeseActividadDirectaByID,
        loadingGetDeclaracionJuradaCeseActividadDirectaByID,
        statusGetDeclaracionJuradaCeseActividadDirectaByID
    } = useGetDeclaracionJuradaCeseActividadDirectaByID();

    const {
        getInfoDeclaracionJuradaCeseActividadDirecta,
        loadingGetInfoDeclaracionJuradaCeseActividadDirecta,
        statusGetInfoDeclaracionJuradaCeseActividadDirecta
    } = useGetInfoDeclaracionJuradaCeseActividadDirecta();

    const {
        dataGetDeclaracionJuradaCeseActividadDirectaByUser,
        getDeclaracionJuradaCeseActividadDirectaByUser,
        loadingGetDeclaracionJuradaCeseActividadDirectaByUser,
        statusGetDeclaracionJuradaCeseActividadDirectaByUser
    } = useGetDeclaracionJuradaCeseActividadDirectaByUser();

    const [currentHttp, setCurrentHttp] = useState({
        status: null,
        statusText: null
    });

    const title = "Declaración jurada cese definitivo por motivos económicos, técnicos y productivos de Estimación directa";
    const navigate = useNavigate();

    const tokenResponse = useDecode("token");
    const userId = tokenResponse?.extension_id;
    
    const expedienteIdByOrigen = Number(origen) === 1 ? (expedienteId ?? null) : null;
    const dataUserWithExpedienteByOrigen = (data) => (expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined ? { ...data, ExpedienteId: expedienteIdByOrigen } : data);

    const [dataUser, setDataUser] = useState<any>(null);
    const [info, setInfo] = useState(false);
    const [showGenerateButton, setShowGenerateButton] = useState(true);
    const [formRenderKey, setFormRenderKey] = useState(0);
    const [generateKey, setGenerateKey] = useState(0);
    const activeRequestRef = useRef(0);
    ////////////////////////////////////////
    // Carga inicial
    ////////////////////////////////////////
    useEffect(() => {
        getDeclaracionJuradaCeseActividadDirectaByUser(userId, expedienteIdByOrigen);
    }, []);

    ////////////////////////////////////////
    // Unificación HTTP
    ////////////////////////////////////////
    useEffect(() => {
        if (statusGetDeclaracionJuradaCeseActividadDirectaByID?.status) {
            setCurrentHttp({
                status: statusGetDeclaracionJuradaCeseActividadDirectaByID.status,
                statusText: statusGetDeclaracionJuradaCeseActividadDirectaByID.statusText
            });
        } else if (statusGetInfoDeclaracionJuradaCeseActividadDirecta?.status) {
            setCurrentHttp({
                status: statusGetInfoDeclaracionJuradaCeseActividadDirecta.status,
                statusText: statusGetInfoDeclaracionJuradaCeseActividadDirecta.statusText
            });
        } else if (statusGetDeclaracionJuradaCeseActividadDirectaByUser?.status) {
            setCurrentHttp({
                status: statusGetDeclaracionJuradaCeseActividadDirectaByUser.status,
                statusText: statusGetDeclaracionJuradaCeseActividadDirectaByUser.statusText
            });
        }
    }, [
        statusGetDeclaracionJuradaCeseActividadDirectaByID,
        statusGetInfoDeclaracionJuradaCeseActividadDirecta,
        statusGetDeclaracionJuradaCeseActividadDirectaByUser
    ]);

    ////////////////////////////////////////
    // Selección fila
    ////////////////////////////////////////
    const rowSelected = (args: any) => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setDataUser(null);
        setInfo(false);
        getDeclaracionJuradaCeseActividadDirectaByID(
            args.data.UsuarioId,
            args.data.PrestacionId,
            args.data.Id,
            (data) => {
                if (activeRequestRef.current === requestId) {
                    setDataUser(dataUserWithExpedienteByOrigen(data));
                }
            }
        );
    };

    ////////////////////////////////////////
    // Generar formulario
    ////////////////////////////////////////
    const handleInfo = async () => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setGenerateKey(prev => prev + 1);
        setDataUser(null);
        setInfo(true);
        await getInfoDeclaracionJuradaCeseActividadDirecta(userId, (data) => {
            if (activeRequestRef.current === requestId) {
                setDataUser(dataUserWithExpedienteByOrigen(data));
            }
        });
    };

    ////////////////////////////////////////
    // Mostrar botón generar
    ////////////////////////////////////////
    useEffect(() => {
        const arrData = dataGetDeclaracionJuradaCeseActividadDirectaByUser;

        if (arrData && Array.isArray(arrData)) {
            const hasFormZero = arrData.some(item => item.EstadoFormulario === 0);
            setShowGenerateButton(!hasFormZero);
        }
    }, [dataGetDeclaracionJuradaCeseActividadDirectaByUser]);

    ////////////////////////////////////////
    // Loader unificado
    ////////////////////////////////////////
    const isLoading = () => {
        return (
            loadingGetDeclaracionJuradaCeseActividadDirectaByID ||
            loadingGetInfoDeclaracionJuradaCeseActividadDirecta ||
            (loadingGetDeclaracionJuradaCeseActividadDirectaByUser && !dataUser)
        );
    };

    return (
        <div className="container bg-#EEEEEE management-new-forms-typography">
            <PageMenu title={title}>
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>

            <div className="container">
                <ManagementFormCardList dataSource={dataGetDeclaracionJuradaCeseActividadDirectaByUser || []} onSelect={rowSelected} key={generateKey} />
            </div>

            {showGenerateButton && (
                <div className="container">
                    <div className="delta-buttons c-right">
                        <button className="btn-box btn-accent" onClick={handleInfo}>
                            Generar Formulario
                        </button>
                    </div>
                </div>
            )}

            <Loader activeLoader={isLoading()} label="Cargando Formulario" />

            {/* SUCCESS */}
            {dataUser && currentHttp.status === 200 && (
                <div className="mt-5">
                    <DeclaracionJuradaCeseActividadDirecta
                        key={`${info ? "create" : "edit"}-${dataUser?.Id ?? "new"}-${formRenderKey}`}
                        dataUser={dataUser}
                        info={info}
                        onSuccess={() => getDeclaracionJuradaCeseActividadDirectaByUser(userId, expedienteIdByOrigen)}
                    />
                </div>
            )}

            {/* ERROR */}
            {currentHttp.status && currentHttp.status !== 200 && (
                <ErrorDisplay descripcionError={currentHttp.statusText} />
            )}
        </div>
    );
};

export default GridDeclaracionJuradaCeseActividadDirecta;
